import React from 'react'
import { Button } from 'loyal-react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'

let confirmationPage = window.location.pathname.substring(
  0,
  window.location.pathname.indexOf('/', 2)
)

const donationPage = () => {
  window.location.href = '/donation'
}
const getButtonDonation = (onClick) => {
  return (
    <div className='col-12 mb-2 justify-content-center align-self-center'>
      <Button
        className='btn btn-sm btn-featured btn-icon'
        text='Fazer uma doação'
        iconName='icon_donation'
        onClick={onClick}
      />
    </div>
  )
}
const getButtonPrint = (onClick) => {
  return (
    <div className='col-12 justify-content-center align-self-center'>
      <MediaQuery minDeviceWidth={476}>
        <Button
          className='btn btn-sm btn-featured btn-cart btn-icon'
          text='Imprimir Pedido'
          iconName='icon_press'
          onClick={onClick}
        />
      </MediaQuery>
    </div>
  )
}
const PrintButton = props => {
  return (
    <div className='row px-2 pt-2 d-print-none'>
      {confirmationPage === '/confirmation' && (
        props.campaignHasDonation ? (
          getButtonDonation(donationPage)
        ) : (
          ''
        )
      )}
      {
        getButtonPrint(window.print)
      }
    </div>
  )
}
PrintButton.propTypes = {
  campaignHasDonation: PropTypes.bool
}

export default PrintButton



// WEBPACK FOOTER //
// ./src/features/About/PrintButton.js